import { useState, useEffect } from 'react';
import fetchers from '../functions/fetch';
import { post } from '../mocks/postsMocks/postsStore';

const usePost: (id: string) => post | undefined = (id) => {
  const [post, setPost] = useState<post | undefined>(undefined);
  useEffect(() => {
    fetchers.get_post({ post_id: id }).then((res) => {
      if (res.status === 200) {
        setPost(res.data);
      }
    });
  }, [id]);
  return post;
};

export default usePost;
